<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('employee_tags')">
            <app-default-button
                v-if="$can('create_employee_tag')"
                :title="$fieldTitle('add', 'tag', true)"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="employee-tag-table"
            :options="options"
            @action="triggerActions"
        />

        <app-employee-tag-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('employee-tag-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import EmployeeTagMixins from "../../../Mixins/EmployeeTagMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppEmployeeTag",
    mixins: [HelperMixin, EmployeeTagMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/employee-tag/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>
